import {connect} from 'react-redux';
import {BoxHolder as Component} from './BoxHolder';
import {
  createBoxHolder,
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {

  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("plantTanks") &&
     state.notebook.protocolSection.scene.apparatus.plantTanks.some(
       box => box.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.plantTanks[ownProps.id-1].type,
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createBoxHolder: (data)=>{
      dispatch(createBoxHolder(data))
    },
  };
}

export const BoxHolder = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
